export default __webpack_public_path__ + "static/media/btn-buy.ee90d275.png";